import React from "react";
import { Text, VStack } from "@chakra-ui/react";

import { TransitModulesDisplay } from "@components";
import { Module, ModuleWithUpNext, PossibleLocations } from "@constants";
import { UpNextGridStack } from "./UpNextGridStack";

type ModulesUpNextProps = {
  location: PossibleLocations | undefined;
  modulesUpNext: ModuleWithUpNext[];
  recentModules: Module[];
};

/**
 * Top Level Up Next component to handle data fetching.
 * @param {PossibleLocations} location The location from where modules are being fetched.
 */
export function ModulesUpNext({
  location,
  modulesUpNext,
  recentModules,
}: ModulesUpNextProps) {
  return (
    <VStack>
      {location !== undefined ? (
        <TransitModulesDisplay
          transitOrientation="destination"
          location={location}
        />
      ) : null}
      {modulesUpNext.length === 0 ? (
        <Text>No modules up next found at {location}. Congratulations!</Text>
      ) : (
        <UpNextGridStack
          modulesUpNext={modulesUpNext}
          recentModules={recentModules}
        />
      )}
    </VStack>
  );
}
